import type { NamePool } from "@/core/types.js";

export const krNamePool: NamePool = {
  given: {
    male: ["Minjun","Hyunwoo","Junho","Seungwoo","Jinhyun","Donghyun","Sanghoon","Kyunghoon","Taehyun","Jaehoon","Minseok","Jongho","Seokjin","Byunghun","Yongsu","Hyungjun","Sunghoon","Woobin","Jaeseon","Chanwoo"],
    female: ["Jiyeon","Eunji","Soyeon","Hyunji","Minji","Yuna","Soyun","Jiyu","Hyerim","Seoyeon","Dahye","Jisu","Eunha","Sumin","Nayeon","Hayeon","Jiyoung","Sojeong","Haerin","Chaeyeon"],
  },
  family: ["Kim","Lee","Park","Choi","Jung","Kang","Cho","Yoon","Jang","Lim","Han","Oh","Shin","Kwon","Hwang","Ahn","Song","Ryu","Hong","Jeon"],
};
